// import swal from 'sweetalert2'
import Vue from 'vue'
import swal from 'sweetalert2'
// // import $ from 'jquery'
import axios from 'axios'
// import axios from 'axios'

const BaseApi = {
  getUserOfPartner: function (guid, onSuccess, onFailed) {
    var url = Vue.prototype.$api.getHost() + '/config/partner/' + guid + '/user' + '?token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().get(url, function (data) {
      onSuccess(data)
    }, 'json').fail(onFailed)
  },
  getAllUserLogs: function (filter, onSuccess, onFailed) {
    var url = Vue.prototype.$api.getHost() + '/config/users/logs' + '?token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().get(url, filter, function (data) {
      onSuccess(data)
    }, 'json').fail(onFailed)
  },
  getUserLogs: function (guid, onSuccess, onFailed) {
    var url = Vue.prototype.$api.getHost() + '/config/user/' + guid + '/logs' + '?token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().get(url, function (data) {
      onSuccess(data)
    }, 'json').fail(onFailed)
  },
  sendEmailActivation: function (user, onSuccess, onFailed) {
    var url = Vue.prototype.$api.getHost() + '/config/user/' + user.guid + '/sendEmailActivation' + '?token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().post(url, JSON.stringify(user), function (data) {
      onSuccess(data)
    }, 'json').fail(onFailed)
  },
  updateUserData: function (user, onSuccess, onFailed) {
    var url = Vue.prototype.$api.getHost() + '/config/user/' + user.guid + '/data' + '?token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().post(url, JSON.stringify(user), function (data) {
      onSuccess(data)
    }, 'json').fail(onFailed)
  },
  getGroupList: function (onSuccess, onFailed) {
    var url = Vue.prototype.$api.getHost() + '/config/groups/list' + '?token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().get(url, function (data) {
      onSuccess(data)
    }, 'json').fail(onFailed)
  },
  getUserData: function (guid, onSuccess, onFailed) {
    var url = Vue.prototype.$api.getHost() + '/config/user/' + guid + '/data' + '?token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().get(url, function (data) {
      onSuccess(data)
    }, 'json').fail(onFailed)
  },
  getSystemStatistic: function (month, year, onSuccess, onFailed) {
    var url = Vue.prototype.$api.getHost() + '/v1/system/stats/pdf/' + year + '/' + month + '?token=' + Vue.prototype.$api.getCredentials().authToken
    url = [url, Vue.prototype.$api.getJQuery().param({'xAuthToken': Vue.credentials.authToken})].join('?')
    console.log('getSystemStatistic ' + url)
    onSuccess(url)
  },
  getSystemLog: function (filter, onSuccess, onFailed) {
    var url = Vue.prototype.$api.getHost() + '/v1/system/logs/lines/1111?filter=' + filter + '?token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().get(url, function (data) {
      onSuccess(data)
    }, 'html').fail(onFailed)
  },
  compileCSS: function (guid, onSuccess, onFailed) {
    var url = Vue.prototype.$api.getHost() + '/config/partner/' + guid + '/compileCSS' + '?token=' + Vue.prototype.$api.getCredentials().authToken
    Vue.prototype.$api.getJQuery().get(url, function (data) {
      onSuccess(data)
    }, 'json').fail(onFailed)
  },
  setConfiguration: function (guid, currentModule, fnSuccess, fnError) {
    var url = Vue.prototype.$api.getHost() + '/config/partner/' + guid + '/config' + '?token=' + Vue.prototype.$api.getCredentials().authToken
    var data = []
    for (var index in currentModule.modelScheme) {
      var item = currentModule.modelScheme[index]
      if (item.valueType === 'jsonList') {
        try {
          item.value = JSON.stringify(currentModule.modelData[item.name])
        } catch (e) {

        }
      } else {
        item.value = currentModule.modelData[item.name]
      }
      data.push(item)
    }
    var submitData = data

    if (this.isMock) {
      fnSuccess(this.mockData.mails)
      swal(
        'Fehler',
        '',
        'error'
      )
    } else {
      axios({
        method: 'post',
        data: JSON.stringify(submitData),
        url: url,
        responseType: 'json'
      })
        .then(function (response) {
          Vue.prototype.$api.hideIdle()
          if (fnSuccess) {
            fnSuccess(response.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          Vue.prototype.$api.hideIdle()
          if (fnError) {
            fnError(error.response)
          } else {
            Vue.prototype.$eventHub.$emit('errorDlg', error.response)
          }
        })
    }
  },
  getConfiguration: function (guid, currentModule, onSuccess, onFailed) {
    var url = Vue.prototype.$api.getHost() + '/config/partner/' + guid + '/config' + '?token=' + Vue.prototype.$api.getCredentials().authToken
    var getData = {}
    if (this.isMock) {
      onSuccess(this.mockData.mails)
    } else {
      Vue.prototype.$api.getJQuery().get(url, JSON.stringify(getData), function (data) {
        if (currentModule) {
          if (currentModule.requestConfiguration) {
            currentModule.modelData = currentModule.requestConfiguration
          } else {
            currentModule.modelData = {}
          }
          data.unshift(currentModule.modelScheme)
          for (var index in data) {
            var item = data[index]
            if (item.valueType === 'jsonList') {
              if (item.value) {
                try {
                  currentModule.modelData[item.name] = JSON.parse(item.value)
                } catch (e) {
                }
              }
            } else if (item.valueType === 'boolean') {
              if (item.value) {
                try {
                  currentModule.modelData[item.name] = item.value.toLowerCase() === 'true'
                } catch (e) {
                }
              } else {
                currentModule.modelData[item.name] = false
              }
            } else {
              currentModule.modelData[item.name] = item.value
            }
          }
        }
        onSuccess(data)
      }, 'json')
    }
  },
  getConfigurationV2: function (guid, params, currentModule, fnSuccess, fnError) {
    var url = Vue.prototype.$api.getHost() + '/v2/config/partner/' + guid + '/config' + '?token=' + Vue.prototype.$api.getCredentials().authToken
    var getData = {
      params: params
    }
    axios({
      method: 'post',
      data: JSON.stringify(getData),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        var data = response.data
        Vue.prototype.$api.hideIdle()
        if (currentModule) {
          if (currentModule.requestConfiguration) {
            currentModule.modelData = currentModule.requestConfiguration
          } else {
            currentModule.modelData = {}
          }
          data.unshift(currentModule.modelScheme)
          for (var index in data) {
            var item = data[index]
            if (item) {
              if (item.valueType === 'jsonList') {
                if (item.value) {
                  try {
                    if (item.name) {
                      currentModule.modelData[item.name] = JSON.parse(item.value)
                    }
                  } catch (e) {
                  }
                }
              } else if (item.valueType === 'boolean') {
                if (item.value) {
                  try {
                    currentModule.modelData[item.name] = item.value.toLowerCase() === 'true'
                  } catch (e) {
                  }
                } else {
                  currentModule.modelData[item.name] = false
                }
              } else {
                if (item.name) {
                  currentModule.modelData[item.name] = item.value
                }
              }
            }
          }
        }
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  },
  onFailed: function (e) {
    console.log('onFailed', e)
  },
  getRecipients: function (onSuccess, onFailed) {
    var url = Vue.prototype.$api.getHost() + '/v1/recipientsFromService' + '?token=' + Vue.prototype.$api.getCredentials().authToken
    var getData = {}
    if (this.isMock) {
      onSuccess(this.mockData.mails)
    } else {
      Vue.prototype.$api.getJQuery().get(url, JSON.stringify(getData), function (data) {
        onSuccess(data)
      }, 'json')
    }
  },
  saveMail: function (partnerGuid, templateName, mailContent, onSuccess, onFailed) {
    var url = Vue.prototype.$api.getHost() + '/config/partner/mails/' + partnerGuid + '/' + templateName + '?token=' + Vue.prototype.$api.getCredentials().authToken
    var submitData = mailContent
    if (this.isMock) {
      onSuccess(this.mockData.mails)
    } else {
      Vue.prototype.$api.getJQuery().post(url, submitData, function (data) {
        console.log(data)
        onSuccess(data)
      }, 'json')
    }
  },
  createPartner: function (data, onSuccess, onFailed) {
    var url = Vue.prototype.$api.getHost() + '/config/partner/create' + '?token=' + Vue.prototype.$api.getCredentials().authToken
    var submitData = data
    if (this.isMock) {
      onSuccess({})
    } else {
      Vue.prototype.$api.getJQuery().post(url, JSON.stringify(submitData), function (data) {
        onSuccess(data)
      }, 'json')
    }
  },
  deletePartner: function (data, onSuccess, onFailed) {
    var url = Vue.prototype.$api.getHost() + '/config/partner/delete/' + data.guid + '?token=' + Vue.prototype.$api.getCredentials().authToken
    var submitData = data
    if (this.isMock) {
      onSuccess({})
    } else {
      Vue.prototype.$api.getJQuery().post(url, JSON.stringify(submitData), function (data) {
        onSuccess(data)
      }, 'json')
    }
  },
  checkMail: function (guid, mailto, tplName, onSuccess, onFailed) {
    var url = Vue.prototype.$api.getHost() + '/config/partner/mails/' + guid + '/check/' + tplName + '?token=' + Vue.prototype.$api.getCredentials().authToken
    var submitData = {
      mailTo: mailto,
      partnerGuid: guid
    }
    if (this.isMock) {
      onSuccess({})
    } else {
      Vue.prototype.$api.getJQuery().post(url, submitData, function (data) {
        onSuccess(data)
      }, 'json')
    }
  },
  loadMails: function (guid, onSuccess, onFailed) {
    var url = Vue.prototype.$api.getHost() + '/config/partner/mails/' + guid + '?token=' + Vue.prototype.$api.getCredentials().authToken
    var getData = {}
    if (this.isMock) {
      onSuccess(this.mockData.mails)
    } else {
      Vue.prototype.$api.getJQuery().get(url, JSON.stringify(getData), function (data) {
        onSuccess(data)
      }, 'json')
    }
  },
  loadPartner: function (onSuccess, onFailed) {
    var url = Vue.prototype.$api.getHost() + '/config/partner/list' + '?token=' + Vue.prototype.$api.getCredentials().authToken
    var getData = {}
    if (this.isMock) {
      onSuccess(this.mockData.partner)
    } else {
      Vue.prototype.$api.getJQuery().get(url, JSON.stringify(getData), function (data) {
        onSuccess(data)
      }, 'json')
    }
  },
  loadPartnerByGuid: function (forceReload, guid, onSuccess, onFailed) {
    Vue.prototype.$api.showIdle()
    var url = Vue.prototype.$api.getHost() + '/config/partner/' + guid + '?token=' + Vue.prototype.$api.getCredentials().authToken
    if (!forceReload) {
      if (Vue.prototype.$api.currentPartner != null) {
        onSuccess(Vue.prototype.$api.currentPartner)
      }
    }
    var getData = {}
    if (this.isMock) {
      onSuccess(this.mockData.partner)
    } else {
      Vue.prototype.$api.getJQuery().get(url, JSON.stringify(getData), function (data) {
        Vue.prototype.$api.hideIdle()
        onSuccess(data)
      }, 'json')
    }
  }
}
export default BaseApi



// WEBPACK FOOTER //
// ./src/admin.js